import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",     
            provincia_id: null,
            localidad_id: null,       
            postVariables: ['nombre', 'provincia_id', 'localidad_id'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            nombre: "",
            provincia_id: null,
            localidad_id: null,
            errors: [],
        });
    }

    getData() {
        const { postVariables} = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                nombre: data.nombre,
                provincia_id: data.provincia ? data.provincia.id : null,
                localidad_id: data.localidad ? data.localidad.id : null,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Sucursal",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Sucursal ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Sucursal",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Sucursal ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Sucursal",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Sucursal",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Sucursal ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const { nombre , provincia_id, localidad_id} = this.state;
        let vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.geograficas.sucursales : null)}
                submitUrl={(vars.submitType ? api.geograficas.sucursales : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="ui-paradigma-modal"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la sucursal</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            maxLength={50}
                            label={"Nombre"}
                            value={nombre}
                            onChange={(e) => this.onChangeField('nombre', e.target.value)}
                            error={() => this.getError('nombre')}
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Provincia"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={vars.disabled}
                                    url={api.geograficas.provincias}
                                    parameters={{
                                        sort:['nombre'],
                                        paginationEnabled:false,
                                    }}
                                    value={provincia_id}
                                    onChange={(data) => this.onChangeField('provincia_id', (data ? data.id : null))}
                                />
                            }
                            error={() => this.getError('provincia_id')}
                        />

                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Localidad"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        url={provincia_id ? api.geograficas.localidades : ''}
                                        parameters={{
                                                paginationEnabled:false,
                                                sort:['nombre'],
                                                concat:provincia_id ? `provincia=${provincia_id}` : ''
                                        }}
                                        disabled={!provincia_id || vars.disabled}
                                        value={localidad_id}
                                        onChange={(data) => this.onChangeField('localidad_id', (data ? data.id : null))}
                                    />
                                }
                                error={() => this.getError('localidad_id')}
                            />
                        </div>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Geograficas/Sucursales/Modal.js